import { render, staticRenderFns } from "./newsStoryADT.vue?vue&type=template&id=17e1e9d2&scoped=true"
import script from "./newsStoryADT.vue?vue&type=script&lang=js"
export * from "./newsStoryADT.vue?vue&type=script&lang=js"
import style0 from "./newsStoryADT.vue?vue&type=style&index=0&id=17e1e9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1e9d2",
  null
  
)

export default component.exports